//styles
import styles from '../styles/bim.module.scss';

//modules
import { useContext, useEffect } from 'react';
import { Context } from '../Context';
import { useTranslation } from 'react-i18next';

//components
import ProjectVisualization from './ProjectVisualization';

function VisualizationView() {

    const { loading, buildingsData, projectEdifices } = useContext(Context);
    const { t } = useTranslation();

    // useEffect(() => {
    //     sliderVis = document.querySelector('#visualisations');
    // }, [loading])
    // useEffect(() => {
       
    // }, [])

    return (
        buildingsData && (
            <>
                <div
                    className={styles.visualizations}
                    id="visualization">
                    {buildingsData && buildingsData.length > 0 ? (
                        <ProjectVisualization key={buildingsData[0].name} edifice={buildingsData[0]} />
                        // buildingsData.map((edifice) => (
                        //     <EdificeVisualization key={edifice.name} edifice={edifice} />
                        // ))
                    ) : (
                        <p>{t('no_edifices_found')}</p>
                    )}
                </div>
            </>
        )
    );
};

export default VisualizationView